import { toast } from "@/components/Toast";
import { LabelText } from "@/modules/editor/components/styleComponents/Texts";
import { cloudProjectActions } from "@/modules/projects/projectProcessor";
import { CloudProjectType } from "@/modules/projects/types/cloud";
import { Project_Words, useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { sensitiveWordCheck } from "@/utils/string";
import {
  Button,
  Center,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";

const IDeleteProjectModal: React.FC<{
  project?: CloudProjectType;
  open: boolean;
  onClose: () => void;
}> = ({ project, open, onClose }) => {
  const { translate } = useTranslate();
  const [loading, setLoading] = useState(false);

  function handleDeleteProject() {
    if (loading || !project) return;
    setLoading(true);
    cloudProjectActions
      .deleteCloudProject(project.project_id)
      .then(() => {
        onClose();
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Modal isCentered variant="dark" size="md" isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p="0 78px">
          <Center py="30px" fontSize="18px" fontWeight={500}>
            {translate(Project_Words["cloud_switch_modal_delete_project"])}
          </Center>
          <Flex flexDirection="column" mb="5px">
            <LabelText mb="11px">
              {translate(Project_Words["cloud_project_delete_modal_warn"]).replace(
                "$",
                project?.project_name ?? "",
              )}
            </LabelText>
          </Flex>
        </ModalBody>
        <ModalFooter py="50px">
          <Button
            variant="outline"
            w="120px"
            bg="fill.button"
            borderColor="#595959"
            mr="16px"
            onClick={onClose}
          >
            {translate(Editor_Words["cancel_button"])}
          </Button>
          <Button
            borderColor="#ff5050"
            w="120px"
            bg="#ff5050"
            _hover={{
              bg: "#ff5050",
            }}
            disabled={loading}
            loadingText={translate(Project_Words["cloud_project_delete_modal_confirm"])}
            isLoading={loading}
            onClick={handleDeleteProject}
          >
            {translate(Project_Words["cloud_project_delete_modal_confirm"])}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const DeleteProjectModal = observer(IDeleteProjectModal);
